import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import LoginPage from './features/auth/LoginPage';
import ForgotPasswordPage from './features/auth/ForgotPasswordPage';
import SecurityRecover from './features/auth/SecurityRecover';
import RPassword from './features/auth/ResetPassword';


// participant section
import PHLayout from './features/participant/ParticipantHomepageLayout';
import UsrProfileLayout from './features/participant/profile/UserProfileLayout';



import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import ALayout from './features/admin/AdminLayout';
import UsrControl from './features/admin/UserControl';
import EvntHistory from './features/admin/EventHistory';
import Mhistory from './features/admin/MatchHistory';
import MReport from './features/admin/MatchReport';
import AdmAccountLayout from './features/admin/profile/AdminAccountLayout';

import OrgDashboard from './features/organizer/OrganizerDashboard';
import OrgAccountLayout from './features/organizer/OrganizerAcountLayout';
import ProtectedRoute from './features/ProtectedRoute';

import MainHomePage from './features/MainHome';
import SignUpFlow from './features/auth/SignUpFlow';
import SetupSecurityRecover from './features/auth/SetupRecovery';



// testing area here
import TPage from './testings/TestPage';

import Scan from './testings/Scan';

import RedirectIfAuthenticated from './hooks/RedirectIfAuthenticated';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function App() {
  return (
    <Router>

      <Routes>
        {/* Public Routes */}

        <Route element={<RedirectIfAuthenticated />}>
          <Route path="/" element={<MainHomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot" element={<ForgotPasswordPage />} />
          <Route path="/register" element={<SignUpFlow />} />
          <Route path="/security" element={<SecurityRecover />} />
          <Route path="/reset" element={<RPassword />} />

          <Route path="/test" element={<TPage />} />
          <Route path="/Scan" element={<Scan />} />

        </Route>

        {/* setting up first registration */}
        <Route path="/security-setup" element={<SetupSecurityRecover />} />



        <Route
          path="/participant"
          element={
            <ProtectedRoute requiredRole="sport_participant">
              <PHLayout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/participant/profile"
          element={
            <ProtectedRoute requiredRole="sport_participant">
              <UsrProfileLayout />
            </ProtectedRoute>
          }
        />



        {/* Protected Admin Routes with Nested Layout */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredRole="admin">
              <ALayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="user-control" replace />} />
          <Route path="user-control" element={<UsrControl />} />
          <Route path="event-history" element={<EvntHistory />} />
          <Route path="match-history" element={<Mhistory />} />
          <Route path="match-report" element={<MReport />} />
        </Route>

        <Route
          path="/admin/profile"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdmAccountLayout />
            </ProtectedRoute>
          }
        />


        {/* Protected Organizer Routes */}
        <Route
          path="/organizer"
          element={
            <ProtectedRoute requiredRole="sport_organizer">
              <OrgDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/organizer/profile"
          element={
            <ProtectedRoute requiredRole="sport_organizer">
              <OrgAccountLayout />
            </ProtectedRoute>
          }
        />

        {/* Catch-all Route */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
    </Router>
  );
}

export default App;